export default __webpack_public_path__ + "static/media/kitchen3-afterF-1024w.aeef9dcc.avif";